// Paging and caching constants for the two editions grids — the gallery
// (`/editions/gallery`) and a series' editions (`/editions/series/[slug]`).
//
// They live here rather than beside either loader because both loaders now
// come in a REST and a GraphQL flavour (rest-migration/feature-flags.md) and
// the two must page identically: the flag decides where the rows come from,
// never how many. `editionsGalleryBrowse` and `seriesPageLoadGql` re-export
// them so the GraphQL path's existing imports are unchanged.
export const EDITIONS_GALLERY_LIMIT = 36;
export const EDITIONS_GALLERY_STALE_TIME = 1000 * 60 * 60;

export const SERIES_GALLERY_LIMIT = 36;
export const SERIES_GALLERY_STALE_TIME = 1000 * 60 * 60;
